import useShippingCountry from '../useShippingCountry';
export function useLocalization() {
  var _useNuxt2App = useNuxt2App(),
    locale = _useNuxt2App.i18n.locale;
  var _useShippingCountry = useShippingCountry(),
    country = _useShippingCountry.country;
  // TODO: change the currency when new currency will be added
  var currency = 'EUR';
  return {
    locale: locale,
    country: country.value,
    currency: currency
  };
}